import React from 'react';
import { ProjectList } from '../components/ProjectList';

export const Projects: React.FC = () => {
  return <ProjectList />;
};